module.exports = __webpack_public_path__ + "static/favicon-6e5c342559f5d91e872913ab17955d62.png";